<template>
  <div class="car">
    <Header :title="(carId != undefined && carId != '' && carId != null) ?'修改车辆':'添加车辆' " :show="true" />
    <van-form @submit="onSave" label-width="60" validate-first ref="carForm">
      <div class="main">
        <van-cell-group>
          <!-- <van-row>
            <van-col span="4">
              <van-field
                readonly
                clickable
                name="area"
                :value="area"
                @click="showArea = true"
                ref="area"
                is-link
              />
            </van-col>
            <van-col span="20">
              <van-field
                v-model="carNo"
                name="carNo"
                placeholder="请输入车牌号码"
                ref="carNo"
                clearable
                required
              />
            </van-col>
            <van-popup v-model="showArea" position="bottom" round>
              <van-picker :columns="areaList" @confirm="onConfirm" @cancel="showArea = false" :show-toolbar="true" :default-index="0"/>
            </van-popup>
          </van-row> -->
          <van-field
            v-model="carNo"
            name="carNo"
            label="车牌号码"
            placeholder="请输入车牌号码"
            ref="carNo"
            clearable
            required
            :rules="[{ pattern: patternCarNo, message: '请输入正确的车牌号' }]"
          />
          <van-field
            clickable
            readonly
            name="carType"
            label="车辆类型"
            :value="carTypeDesc"
            placeholder="点击选择车辆类型"
            @click="showCarTypePicker = true"
            is-link
            ref="carType"
          />
          <van-popup v-model="showCarTypePicker" position="bottom" round :lazy-render='false'>
            <van-picker
              title="选择车辆"
              show-toolbar
              :columns="carTypeList"
              @confirm="onConfirmCarType"
              @cancel="showCarTypePicker = false"
              :default-index="0"
            >
              <template #option="carType">
                <span>{{ carType.desc }}</span>
              </template>
            </van-picker>
          </van-popup>
          <van-notice-bar
            wrapable
            :scrollable="false"
            text=""
            background="white"
          />
          <van-field
            v-model="carEngine"
            name="carEngine"
            label="发动机号"
            placeholder="请输入发动机号后6位"
            ref="carEngine"
            :maxlength="6"
            clearable
          />
          <van-field
            v-model="carIdentification"
            name="carIdentification"
            label="识别代号"
            placeholder="请输入车辆识别代号后6位"
            ref="carIdentification"
            :maxlength="6"
            clearable
          />
          <van-field
            v-model="carOwnerName"
            name="carOwnerName"
            label="车主姓名"
            placeholder="请输入车主姓名"
            ref="carOwnerName"
            clearable
          />
          <van-field
            v-model="carModel"
            name="carModel"
            label="品牌型号"
            placeholder="请输入品牌型号"
            ref="carModel"
            clearable
          />
          <van-field
            readonly
            clickable
            name="carSignDate"
            :value="carSignDate"
            label="注册日期"
            placeholder="点击选择日期"
            @click="showCarSignDatePicker = true"
            ref="carSignDate"
            clearable
          />
          <van-popup v-model="showCarSignDatePicker" position="bottom" round>
            <van-datetime-picker
              type="date"
              title="选择年月日"
              @confirm="onConfirmCarSignDate"
              @cancel="showCarSignDatePicker = false"
            />
          </van-popup>
          <van-field
            readonly
            clickable
            name="carCertificateDate"
            :value="carCertificateDate"
            label="发证日期"
            placeholder="点击选择日期"
            @click="showCarCertificateDatePicker = true"
            ref="carCertificateDate"
            clearable
          />
          <van-popup v-model="showCarCertificateDatePicker" position="bottom" round>
            <van-datetime-picker
              type="date"
              title="选择年月日"
              @confirm="onConfirmCarCertificateDate"
              @cancel="showCarCertificateDatePicker = false"
            />
          </van-popup>
        </van-cell-group>
      </div>
      <div style="margin-top:15px;">
        <van-button
          block
          type="info"
          color="var(--depYelColor)"
          native-type="submit"
        >{{(carId != undefined && carId != '' && carId != null)?'保存':'提交'}}</van-button>
      </div>
      <div style="margin-top:15px;" v-if="carId != undefined && carId != '' && carId != null">
        <van-button native-type="button" block type="default" @click="onDelete">删除</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { getAddressInfo } from "api/user";
import area from "server/data/address";
import { wechatAuth } from "api/wechatSDK";
import { addCar, getCarInfo, deleteOneCar } from 'api/car'

export default {
  data() {
    return {
      carId: '',
      area: "粤",
      areaList: ['粤', '京', '津', '冀', '晋', '蒙', '辽', '吉', '黑', '沪', '苏', '浙', '皖', '闽', '赣', '鲁', '豫', '鄂', '湘', '桂', '琼', '川', '贵', '云', '渝', '藏', '陕', '甘', '青', '宁', '新', '港', '澳', '台'],
      showArea: false,
      carNo: '粤',
      carEngine: '',
      carIdentification: '',
      carTypeDesc: '小型汽车',
      carType: '02',
      carTypeList: [
        { desc: '小型汽车', val: '02'},
        { desc: '大型汽车', val: '01' },
        { desc: '新能源-小型汽车', val: '52' },
        { desc: '新能源-大型汽车', val: '51' },
      ],
      carModel: '',
      showCarTypePicker: false,
      carOwnerName: '',
      carSignDate: null,
      carCertificateDate: null,
      showCarSignDatePicker: false,
      showCarCertificateDatePicker: false,
      // columns: [
      //   { text: '粤', value: '粤' },
      //   { text: '京', value: '京' },
      //   { text: '津', value: '津' },
      //   { text: '冀', value: '冀' },
      //   { text: '晋', value: '晋' },
      //   { text: '蒙', value: '蒙' },
      //   { text: '辽', value: '辽' },
      //   { text: '吉', value: '吉' },
      //   { text: '黑', value: '黑' },
      //   { text: '沪', value: '沪' },
      //   { text: '苏', value: '苏' },
      //   { text: '浙', value: '浙' },
      //   { text: '皖', value: '皖' },
      //   { text: '闽', value: '闽' },
      //   { text: '赣', value: '赣' },
      //   { text: '鲁', value: '鲁' },
      //   { text: '豫', value: '豫' },
      //   { text: '鄂', value: '鄂' },
      //   { text: '湘', value: '湘' },
      //   { text: '桂', value: '桂' },
      //   { text: '琼', value: '琼' },
      //   { text: '川', value: '川' },
      //   { text: '贵', value: '贵' },
      //   { text: '云', value: '云' },
      //   { text: '渝', value: '渝' },
      //   { text: '藏', value: '藏' },
      //   { text: '陕', value: '陕' },
      //   { text: '甘', value: '甘' },
      //   { text: '青', value: '青' },
      //   { text: '宁', value: '宁' },
      //   { text: '新', value: '新' },
      //   { text: '港', value: '港' },
      //   { text: '澳', value: '澳' },
      //   { text: '台', value: '台' },
      // ],
      patternCarNo: /^[京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-Z0-9]{4}[A-Z0-9挂学警港澳]{1}$/,
    }
  },
  created() {
    // wechatAuth(["openAddress"]);
    // this.areaList = area;
  },
  mounted() {
    let carId = this.$route.query.carId
    if (carId != undefined && carId != '' && carId != null) {
      this.carId = carId;
      this.getCarInfo();
    } else {
      this.$store.commit("setPageLoading", false);
    }
  },
  methods: {
    onConfirm(value) {
      // this.area = values.map((item) => item.name).join("");
      // this.showArea = false;
      this.area = value
      this.showArea = false
    },
    onConfirmCarType(value) {
      this.carType = value.val
      this.carTypeDesc = value.desc
      this.showCarTypePicker = false
    },
    onConfirmCarSignDate(date) {
      // this.value = `${date.getMonth() + 1}/${date.getDate()}`;
      this.carSignDate = this.formatter(date)
      this.showCarSignDatePicker = false
    },
    onConfirmCarCertificateDate(date) {
      // this.value = `${date.getMonth() + 1}/${date.getDate()}`;
      this.carCertificateDate = this.formatter(date)
      this.showCarCertificateDatePicker = false
    },
    formatter(time) {
      if (time == null)  {
        return null
      }
      let nowdata = new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
    onSave() {
      this.$loading("处理中");
      if (this.carId <= 0) {
        addCar(
          "",
          this.carNo,
          this.carEngine,
          this.carIdentification,
          this.carType,
          this.carOwnerName,
          this.carModel,
          this.carSignDate,
          this.carCertificateDate,
        ).then((res) => {
          this.$clear();
          if (res.status == 200) {
            this.$successSync("添加成功", () => {
              this.$push({
                path: "/carList"
              })
            });
          } else {
            this.$error(res.message);
          }
        });
      } else {
        addCar(
          this.carId,
          this.carNo,
          this.carEngine,
          this.carIdentification,
          this.carType,
          this.carOwnerName,
          this.carModel,
          this.carSignDate,
          this.carCertificateDate,
        ).then(
          (res) => {
            this.$clear();
            if (res.status == 200) {
              this.$successSync("修改成功", () => {
                this.$push({
                  path: "/carList",
                });
              });
            } else {
              this.$error(res.message);
            }
          }
        );
      }
    },
    getCarInfo() {
      getCarInfo(this.carId).then((res) => {
        // var resStr = JSON.stringify(res)
        // alert(resStr)
        if (res.status == 200) {
          this.carNo = res.data.carNo
          this.carType = res.data.carType
          this.cartTypeList.forEach(item => {
            if (item.values == this.carType) {
              this.carTypeDesc = item.text
              return;
            }
          })
          // this.$refs.carType.setColumnIndex(this.carType)
          // alert(this.carTypeList[this.cartType].text)
          // alert(JSON.stringify(this.carTypeList[this.carType].text))
          this.carEngine = res.data.carEngine
          this.carIdentification = res.data.carIdentification
          this.carOwnerName = res.data.carOwnerName
          this.carModel = res.data.carModel
          this.carSignDate = this.formatter(res.data.carSignDate)
          this.carCertificateDate = this.formatter(res.data.carCertificateDate)
        } else {
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      });
    },
    onDelete() {
      deleteOneCar(this.carId).then((res) => {
        this.$clear();
        if (res.status == 200) {
          this.$successSync("删除成功", () => {
            this.$push({
              path: "/carList",
            });
          });
        } else {
          this.$error(res.message);
        }
      })
    }
  }
}
</script>
